import { render, staticRenderFns } from "./Memory.vue?vue&type=template&id=5c84bbe6&scoped=true&"
import script from "./Memory.vue?vue&type=script&lang=ts&"
export * from "./Memory.vue?vue&type=script&lang=ts&"
import style0 from "./Memory.vue?vue&type=style&index=0&id=5c84bbe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c84bbe6",
  null
  
)

export default component.exports